<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.85 40.85" style="width: 100%">
        <g id="Capa_2" data-name="Capa 2">
            <polygon class="cls-1"
                     points="40.85 40.85 0 40.85 0 0 17.41 0 17.41 3 3 3 3 37.85 37.85 37.85 37.85 23.43 40.85 23.43 40.85 40.85"/>
            <rect class="cls-1" x="28.09" y="2.73" width="8.61" height="11.08"
                  transform="translate(3.64 25.32) rotate(-45)"/>
            <path class="cls-1"
                  d="M16.52,32,31.14,17.35,23.31,9.51,8.69,24.13a1.5,1.5,0,0,0-.44,1.06V30.9a1.5,1.5,0,0,0,1.5,1.5h5.71A1.49,1.49,0,0,0,16.52,32Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "EditIcon"
}
</script>

<style scoped>
.cls-1 {
    fill: currentColor;
}
</style>
